import { Link, useLocation } from "react-router-dom";
import { subscribeCTALink } from "@components/Footer/constant";
import { gaEventTracker } from "@util/helpers";
import cx from "classnames";

type SubscribeTriggerProps = {
  title?: string;
};

export default function SubscribeTrigger({
  title = "Subscribe",
}: SubscribeTriggerProps): React.ReactElement {
  const location = useLocation();

  const handleClick = () => {
    gaEventTracker("subscribe article header", "click", location.pathname);
  };

  return (
    <Link
      to={subscribeCTALink.header}
      target="_blank"
      rel="noopener"
      className={cx(
        "group cursor-pointer rounded-full bg-orange-300 px-2 py-1 font-poppins font-semibold uppercase text-white",
        "visited:text-white",
        "xl:px-3"
      )}
      data-testid="SubscribeTrigger"
      onClick={handleClick}
    >
      <span
        className={cx("opacity-100 duration-300", "group-hover:opacity-75")}
      >
        {title}
      </span>
    </Link>
  );
}
